import React from 'react';
import { Permission } from '../../data/models/permission.model';
import { BaseNote } from '../../data/models/provider-note.model';
import { useAppSelector } from '../useAppSelector';
import { useHasPermission } from './useHasPermission';
import * as userSlice from '../../data/user.slice';

export const useCanDeleteNote = (note: BaseNote): boolean => {
  const [canDeleteNote, setCanDeleteNote] = React.useState<boolean>(false);
  const user = useAppSelector(userSlice.selectUserInfo);

  const deleteSelfPermission: Permission = {
    resource: 'notes',
    action: 'deletebasic',
    scope: 'self',
  };
  const deleteAllPermission: Permission = {
    resource: 'notes',
    action: 'deletebasic',
    scope: 'all',
  };

  const canDeleteSelf = useHasPermission(user, deleteSelfPermission);
  const canDeleteAll = useHasPermission(user, deleteAllPermission);

  React.useEffect(() => {
    if (user?.access?.permissions) {
      setCanDeleteNote(
        canDeleteAll ||
          (canDeleteSelf && note.createdByUserID === user.userAccountID),
      );
    }
  }, [user, canDeleteSelf, canDeleteAll]);

  return canDeleteNote;
};
